import { render, staticRenderFns } from "./DeleteItemBtn.vue?vue&type=template&id=2a0a0944&scoped=true"
import script from "./DeleteItemBtn.vue?vue&type=script&lang=ts"
export * from "./DeleteItemBtn.vue?vue&type=script&lang=ts"
import style0 from "./DeleteItemBtn.vue?vue&type=style&index=0&id=2a0a0944&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a0944",
  null
  
)

export default component.exports